import Auth from './Auth'
import routerGuard from './routerBeforeGuard'

import { frontendcommonCss, logo, logoSmall, logoColor, logoColorSmall, colors } from './frontendcommon'
import URLS from './urls'

import App from './App'
import SidebarBottom from './SidebarBottom'
import { plugins } from 'frontendcommon-3'
import LoadingSpinner from './LoadingSpinner'

const sidebarLoading = false
const enableMobileLayout = false
const { AxiosPlugin } = plugins

const sentryDns = 'https://100b9bc6c9834f25af58e455461122d3@sentry.farmapremium.es/7'

export {
  Auth,
  routerGuard,
  frontendcommonCss,
  colors,
  logo,
  logoSmall,
  logoColor,
  logoColorSmall,
  enableMobileLayout,
  sidebarLoading,
  SidebarBottom,
  App,
  URLS,
  AxiosPlugin,
  sentryDns,
  LoadingSpinner
}
